import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import './ProductSale.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";
import { Link } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Dropdown from 'react-bootstrap/Dropdown';
import { validateproductsale } from '../../../Utils/validate';
import { gettoastwarning } from '../../../Utils/Common';
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';
import moment from "moment";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

import Editor from 'react-simple-wysiwyg';

const containerStyle = {
  width: "100%",
  height: "300px",
};



const ProductSale = () => {

  //const [html, setHtml] = useState('my <b>HTML</b>');
  
  /*function onChange(e) {
    setHtml(e.target.value);
  }*/

    const [loading, setLoading] = useState(false);
    const [inputs, setInputs] = useState({ listing_title: '', description: '', original_mrp: '', deal_type: '', buy_qty: '', get_qty: '', discount: '', sale_price: '', beat_online_price: '', online_price: '', online_link: '', monthly_deal_limite: '', category_id: '', subcategory_id: '', cat_name: '', sub_cat_name: '', deal_start_date: '', deal_end_date: '', home_delivery: 0 });
    const [inputsb, setInputsb] = useState({ business_name: '', address: '', business_contact_number: '' });
    const [errors, setErrors] = useState({});

    //const [image, setImage] = useState({preview: '', raw: ''});

    const [category, setCategory] = useState([]);

    const [subcategory, setSubcategory] = useState([]);
    const [center, setCenter] = useState({
    lat: null,
    lng: null,
  });

    var adsetting = {
        dots: true,
        arrow: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,              // Enable autoplay
        autoplaySpeed: 3000,         // Set the speed for autoplay (in milliseconds)
        centerMode: false,
        adaptiveHeight: true,            // Enable center mode    
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    useEffect(() => {
        document.title = `Product Sale | Local Bells`;
        document.getElementById('bodywrap').className = 'busiprosale';

        let formData1 = new FormData();
        formData1.append('business_id', localStorage.getItem("business_id"));
        API.post('get_business_detail', formData1)
            .then(response => {

                if (response.data.status === true) {
                    setInputsb({
                        business_name: response.data.data.business_name,
                        address: response.data.data.address,
                        business_contact_number: response.data.data.business_contact_number,
                    });
                    setCenter({
                        lat: response.data.data.latitude,
                        lng: response.data.data.longitude,
                      });
                } else {


                }
            }).catch(error => {

            });

        let formData = new FormData();
        formData.append('business_id', localStorage.getItem("business_id"));
        API.post('get_categories_with_users', formData)
            .then(response => {

                if (response.data.status === true) {
                    setCategory(response.data.data);
                } else {


                }
            }).catch(error => {

            });

    }, []);


    const [images, setImages] = useState([]);

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        const remainingSlots = 5 - images.length;

        if (files.length > remainingSlots) {
            alert(`You can only upload ${remainingSlots} more image(s).`);
            return;
        }
        const imagePreviews = files.map((file) => ({
            file,
            url: URL.createObjectURL(file),
            id: 0,
        }));
        setImages((prev) => [...prev, ...imagePreviews]);
    };

    const handleDelete = (index, id) => {
        /*if(id===0){*/
        const updated = [...images];
        updated.splice(index, 1);
        setImages(updated);
        /*}else{

        }*/
    };


    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };


    // Handle drag events
    /*const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!event.target.files[0].name.match(/\.(jpg|jpeg|png|gif)$/)) {
          gettoastwarning('Please select valid image.','');
        }else{
            setImage({
                preview: URL.createObjectURL(event.target.files[0]),
                raw: event.target.files[0]
            });
        }
    };
    const handleInputChangeImg = (event) => { 
        if (!event.target.files[0].name.match(/\.(jpg|jpeg|png|gif)$/)) {
          gettoastwarning('Please select valid image.','');
        }else{
            setImage({
                preview: URL.createObjectURL(event.target.files[0]),
                raw: event.target.files[0]
            });
        }
    };*/

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);


    const [isVisibleMsg, setIsVisibleMsg] = useState(false);
    const [isStep1, setIsStep1] = useState(true);
    const [isStep2, setIsStep2] = useState(false);


    const wantHandlePublish = () => {
        setIsStep1(false);
        setIsStep2(true);
    };

    /* Start Value set */
    const handleInputChange = (event) => {
        event.persist();
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
    }
    const handleInputChangeCat = (event) => {
        event.persist();
        const id = event.target.value;
        const cat_name = event.target.selectedOptions[0].getAttribute("data-cat-name");
        setInputs(prev => ({
            ...prev,
            category_id: id,
            cat_name: cat_name,
        }));
        if (id !== '') {


            let formData = new FormData();
            formData.append('category_id', id);
            API.post('get_sub_categories_with_users', formData)
                .then(response => {

                    if (response.data.status === true) {
                        setSubcategory(response.data.data);
                    } else {


                    }
                }).catch(error => {

                });
        } else {
            setSubcategory([]);
            const id = '';
            const subcat_name = '';

            setInputs(prev => ({
                ...prev,
                subcategory_id: id,
                sub_cat_name: subcat_name
            }));
        }
    }
    const handleInputChangeSubCat = (event) => {
        event.persist();
        const id = event.target.value;
        const subcat_name = event.target.selectedOptions[0].getAttribute("data-subcat-name");

        setInputs(prev => ({
            ...prev,
            subcategory_id: id,
            sub_cat_name: subcat_name
        }));

    }


    const handleInputChangeMRP = (event) => {
        event.persist();
        const value = event.target.value;

        // Allow only numbers and decimals
        if (/^\d*\.?\d*$/.test(value)) {
            setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
        }
    }
    const handleInputChangeMRPS = (event) => {
        event.persist();
        const value = event.target.value;

        // Allow only numbers and decimals
        if (/^\d*\.?\d*$/.test(value)) {
            setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));


            if (inputs.original_mrp !== '') {
                if (inputs.original_mrp > 0) {
                    var mrp = inputs.original_mrp;
                    //var discountPercentage = (value / mrp) * 100;
                    var discountPercentage = ((mrp - value) / mrp) * 100;
                    var lbl = 'discount';
                    discountPercentage = discountPercentage.toFixed(2);
                    setInputs(inputs => ({ ...inputs, [lbl]: discountPercentage }));
                }
            }


        }
    }
    const handleInputChangeMRPD = (event) => {
        event.persist();
        const value = event.target.value;

        // Allow only numbers and decimals
        if (/^\d*\.?\d*$/.test(value)) {
            setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));


            if (inputs.discount !== '') {
                if (inputs.discount > 0) {
                    var mrp = value;
                    var dis = inputs.discount;
                    const sale_price = mrp - (mrp * dis) / 100;
                    var lbl = 'sale_price';
                    setInputs(inputs => ({ ...inputs, [lbl]: sale_price }));
                }
            }

        }
    }
    const handleInputChangeDisMRP = (event) => {
        event.persist();
        const value = event.target.value;

        // Allow only numbers and decimals
        if (/^\d*\.?\d*$/.test(value)) {
            setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));


            if (inputs.original_mrp !== '') {
                if (inputs.original_mrp > 0) {
                    var mrp = inputs.original_mrp;
                    //var sale_price=mrp*value/100;

                    const sale_price = mrp - (mrp * value) / 100;

                    var lbl = 'sale_price';
                    setInputs(inputs => ({ ...inputs, [lbl]: sale_price }));
                }
            }

        }
    }
    /* End Value set */
    const handleChangeChk = (e) => {
        const value = e.target.checked ? 1 : 0;
        const lbl = 'home_delivery';
        setInputs(inputs => ({ ...inputs, [lbl]: value }));
    };

    // Handle the change in dropdown selection
    const handleOfferChange = (e) => {
        const value = e.target.value;
        const lbl = 'deal_type';
        setInputs(inputs => ({ ...inputs, [lbl]: value }));
        //setSelectedOffer(e.target.value);
    };
    function onChangeDes(event) {
        //setHtml(e.target.value);
            var description_lbl='description';
        setInputs(inputs => ({ ...inputs, [description_lbl]: event.target.value }));
      }
    const handleRadioClick = (value) => {
        const lbl = 'beat_online_price';
        setInputs(inputs => ({ ...inputs, [lbl]: value }));
        //setSelectedOption(value);
    };
    const handleShow = () => {
        const validationErrors = validateproductsale(inputs, images);
        const noErrors = Object.keys(validationErrors).length === 0;
        setErrors({});
        setErrors(validationErrors);

        if (noErrors) {
            setIsStep1(true);
            setIsStep2(false);
            setIsVisibleMsg(false);
            setShow(true);
        }
    }
    const handlePublish = async () => {
        setLoading(true);

        var online_price = '';
        var online_link = '';
        if (inputs.beat_online_price !== 'not_applicable') {
            online_price = inputs.online_price;
            online_link = inputs.online_link;
        }

        let formData = new FormData();
        formData.append('business_id', localStorage.getItem("business_id"));
        formData.append('deal_master_type', 'specific');
        formData.append('description', inputs.description);
        //formData.append('image', image.raw);
        formData.append('deal_start_date', inputs.deal_start_date);
        formData.append('deal_end_date', inputs.deal_end_date);
        formData.append('listing_title', inputs.listing_title);
        formData.append('original_mrp', inputs.original_mrp);
        formData.append('deal_type', inputs.deal_type);
        formData.append('get_qty', inputs.get_qty);
        formData.append('buy_qty', inputs.buy_qty);
        formData.append('sale_price', inputs.sale_price);
        formData.append('beat_online_price', inputs.beat_online_price);
        formData.append('online_price', online_price);
        formData.append('online_link', online_link);
        formData.append('monthly_deal_limite', inputs.monthly_deal_limite);
        formData.append('home_delivery', inputs.home_delivery);
        formData.append('category_id', inputs.category_id);
        formData.append('subcategory_id', inputs.subcategory_id);

        formData.append('discount', inputs.discount);

       

       
        images.forEach((item, index) => {
            if (item.file) {
                formData.append(`image[]`, item.file);
            }
        });
         

        API.post('add_deal', formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {
                    setLoading(false);
                    gettoastwarning(response.data.message, '');
                } else {
                    setIsVisibleMsg(true);
                    setIsStep2(false);
                }
            }).catch(error => {
                setLoading(false);
                gettoastwarning("Something went wrong. Please try again later.", '');
            });
    };
    const handleView = () => {
        window.location.href = '/business/my-deal';
    };
    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <Row>
                                    <Col md={8} lg={8} xl={8} xxl={6}>
                                        <div className='white-box'>
                                            <div className='and-top'>
                                                <h3>Specific Product / Service Deal</h3>
                                                <Link to="/business/my-deal" className='wp-link'>
                                                    <div>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid" alt="wp" />
                                                    </div>
                                                </Link>
                                            </div>
                                            <div className='and-form'>
                                                <Form>

                                                    <Row className='mb-3'>
                                                        <Col xs={12}>
                                                            <Form.Group className="">
                                                                <Form.Label className=''>Listing Title <span className="text-danger">*</span></Form.Label>
                                                                <Form.Control type="text" placeholder="Ex. Nescaffe 100 Gram, LG 32 inch TV" name="listing_title" onChange={handleInputChange} value={inputs.listing_title} maxLength="50" />
                                                            </Form.Group>
                                                            {errors.listing_title && (<p className="text-danger">{errors.listing_title}</p>)}
                                                            <div className='and-note-text'>
                                                                <h6>lorem ipsum fsdsfsfdsfdsfsdf</h6>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className='mb-3'>
                                                        <Col xs={12}>
                                                            <div className=''>
                                                                {/* Dropzone */}
                                                                <div
                                                                    onDragOver={(e) => e.preventDefault()}
                                                                    onDragEnter={(e) => e.preventDefault()}
                                                                    className='gen-upload'

                                                                >
                                                                    <input
                                                                        type="file"
                                                                        accept="image/*"
                                                                        multiple
                                                                        onChange={handleImageChange}
                                                                        id="fileInput"
                                                                        disabled={images.length >= 5}
                                                                    />
                                                                    <label htmlFor="fileInput">
                                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/uploadicn.webp'} className="img-fluid" alt="uploadicn" />
                                                                        <div>
                                                                            <h6>Upload Image</h6>
                                                                            <h6><span className='fw-600'>1920 X 350</span> px</h6>
                                                                        </div>
                                                                    </label>
                                                                </div>
                                                                {/* {errors.images && (<p className="text-danger">{errors.images}</p>)} */}
                                                                {/* Previews */}
                                                                <div className='gen-upload-preview row gap-0'>
                                                                    {images.map((img, index) => (
                                                                        <div className="col-md-3 mb-3">
                                                                            <div className="position-relative anb-upl-img">
                                                                                <img
                                                                                    src={img.url}
                                                                                    alt="Preview"
                                                                                    className="img-fluid rounded"
                                                                                />
                                                                                <button type="button"
                                                                                    className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                                                                                    onClick={() => handleDelete(index, img.id)}
                                                                                >
                                                                                    &times;
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <div className='and-note-text'>
                                                            <h6>lorem ipsum fsdsfsfdsfdsfsdf</h6>
                                                        </div>
                                                    </Row>
                                                    <Row className='mb-3'>
                                                        <Col xs={12}>
                                                            {/*<Form.Group className="">
                                                                <Form.Label className=''>Description</Form.Label>
                                                                <Form.Control as="textarea" rows={4} placeholder='Additional information' name="description" onChange={handleInputChange} value={inputs.description} />
                                                            </Form.Group>*/}
                                                            {/* {errors.description && (<p className="text-danger">{errors.description}</p>)} */}
                                                            <div className='and-note-text'>
                                                                <h6>lorem ipsum fsdsfsfdsfdsfsdf</h6>
                                                            </div>
                                                            <div className='my-3'>
                                                                <Form.Label className=''>Description</Form.Label>
                                                                <Editor value={inputs.description} onChange={onChangeDes} style={{ height: '100px' }}/>
                                                            </div>

                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm={12} className="mb-3">
                                                            <Form.Group >
                                                                <Form.Label className=''>Original MRP <span className="text-danger">*</span></Form.Label>
                                                                <Form.Control type="text" placeholder="Enter price" name="original_mrp" onChange={handleInputChangeMRPD} value={inputs.original_mrp} />
                                                            </Form.Group>
                                                            {errors.original_mrp && (<p className="text-danger">{errors.original_mrp}</p>)}
                                                            <div className='and-note-text'>
                                                                <h6>lorem ipsum fsdsfsfdsfdsfsdf</h6>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className='off-box'>
                                                        <Col xs={12} className='mb-3'>
                                                            <Form.Label className=''>Your offer <span className="text-danger">*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="deal_type" onChange={handleOfferChange} value={inputs.deal_type}>
                                                                <option value="">Select Your offer</option>
                                                                <option value="1">% Discount</option>
                                                                <option value="2">Buy X Get X Free Offer</option>

                                                            </Form.Select>
                                                            {errors.deal_type && (<p className="text-danger">{errors.deal_type}</p>)}
                                                            <div className='and-note-text'>
                                                                <h6>lorem ipsum fsdsfsfdsfdsfsdf</h6>
                                                            </div>
                                                        </Col>
                                                        {inputs.deal_type === "2" && (
                                                            <>
                                                                <Col sm={6} className='mb-3 offer-box'>
                                                                    <Form.Group >
                                                                        <Form.Label className=''>Buy Qty <span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control type="text" placeholder="10" name="buy_qty" onChange={handleInputChangeMRP} value={inputs.buy_qty} />
                                                                    </Form.Group>
                                                                    {errors.buy_qty && (<p className="text-danger">{errors.buy_qty}</p>)}
                                                                    <div className='and-note-text'>
                                                                        <h6>lorem ipsum fsdsfsfdsfdsfsdf</h6>
                                                                    </div>
                                                                </Col>
                                                                <Col sm={6} className='mb-3 offer-box'>
                                                                    <Form.Group >
                                                                        <Form.Label className=''>Get Qty <span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control type="text" placeholder="20" name="get_qty" onChange={handleInputChangeMRP} value={inputs.get_qty} />
                                                                    </Form.Group>
                                                                    {errors.get_qty && (<p className="text-danger">{errors.get_qty}</p>)}
                                                                    <div className='and-note-text'>
                                                                        <h6>lorem ipsum fsdsfsfdsfdsfsdf</h6>
                                                                    </div>
                                                                </Col>
                                                            </>
                                                        )}

                                                        {inputs.deal_type === "1" && (
                                                            <>
                                                                <Col sm={6} className='mb-3 discount-box'>
                                                                    <Form.Group >
                                                                        <Form.Label className=''>% Discount <span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control type="text" placeholder="% 5" name="discount" onChange={handleInputChangeDisMRP} value={inputs.discount} maxLength={2} />
                                                                    </Form.Group>
                                                                    {errors.discount && (<p className="text-danger">{errors.discount}</p>)}
                                                                    <div className='and-note-text'>
                                                                        <h6>lorem ipsum fsdsfsfdsfdsfsdf</h6>
                                                                    </div>
                                                                </Col>
                                                                <Col sm={6} className='mb-3 discount-box'>
                                                                    <Form.Group >
                                                                        <Form.Label className=''>Your Sale Price <span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control type="text" placeholder="Enter price" name="sale_price" onChange={handleInputChangeMRPS} value={inputs.sale_price} />
                                                                    </Form.Group>
                                                                    {errors.sale_price && (<p className="text-danger">{errors.sale_price}</p>)}
                                                                    <div className='and-note-text'>
                                                                        <h6>lorem ipsum fsdsfsfdsfdsfsdf</h6>
                                                                    </div>
                                                                </Col>
                                                            </>
                                                        )}
                                                    </Row>
                                                    <Row className='mb-3'>
                                                        <Col md={12}>
                                                            <Form.Label className=''>Are you going to beat online price? <span className="text-danger">*</span></Form.Label>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <div className="poll-radio" onClick={() => handleRadioClick('yes')}>
                                                                <h6>Yes</h6>
                                                                <div className="radio-wrapper">
                                                                    <input
                                                                        type="radio"
                                                                        id="yes"
                                                                        name="poll"
                                                                        value="yes"
                                                                        checked={inputs.beat_online_price === 'yes'}
                                                                        onChange={() => { }}
                                                                    />
                                                                    <label htmlFor="yes" className={`radio-label ${inputs.beat_online_price === 'yes' ? 'checked' : ''}`}>
                                                                        {/*<Image
                                                                            src={inputs.beat_online_price === 'yes' ? "../assets/images/radio-checked.webp" : "../assets/images/radio.webp"}
                                                                            className="img-fluid"
                                                                            alt="radio state"
                                                                        />*/}
                                                                        <Image
                                                                            src={
                                                                                inputs.beat_online_price === 'yes'
                                                                                    ? process.env.REACT_APP_BASE_URL + 'assets/images/radio-checked.webp'
                                                                                    : process.env.REACT_APP_BASE_URL + 'assets/images/radio.webp'
                                                                            }
                                                                            className="img-fluid"
                                                                            alt="radio state"
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <div className="poll-radio" onClick={() => handleRadioClick('no')}>
                                                                <h6>No</h6>
                                                                <div className="radio-wrapper">
                                                                    <input
                                                                        type="radio"
                                                                        id="no"
                                                                        name="poll"
                                                                        value="no"
                                                                        checked={inputs.beat_online_price === 'no'}
                                                                        onChange={() => { }}
                                                                    />
                                                                    <label htmlFor="no" className={`radio-label ${inputs.beat_online_price === 'no' ? 'checked' : ''}`}>
                                                                        {/*<Image
                                                                            src={inputs.beat_online_price === 'no' ? "../assets/images/radio-checked.webp" : "../assets/images/radio.webp"}
                                                                            className="img-fluid"
                                                                            alt="radio state"
                                                                        />*/}
                                                                        <Image
                                                                            src={
                                                                                inputs.beat_online_price === 'no'
                                                                                    ? process.env.REACT_APP_BASE_URL + 'assets/images/radio-checked.webp'
                                                                                    : process.env.REACT_APP_BASE_URL + 'assets/images/radio.webp'
                                                                            }
                                                                            className="img-fluid"
                                                                            alt="radio state"
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <div className="poll-radio" onClick={() => handleRadioClick('not_applicable')}>
                                                                <h6>Not Applicable</h6>
                                                                <div className="radio-wrapper">
                                                                    <input
                                                                        type="radio"
                                                                        id="not"
                                                                        name="poll"
                                                                        value="not_applicable"
                                                                        checked={inputs.beat_online_price === 'not_applicable'}
                                                                        onChange={() => { }}
                                                                    />
                                                                    <label htmlFor="not" className={`radio-label ${inputs.beat_online_price === 'not_applicable' ? 'checked' : ''}`}>
                                                                        {/*<Image
                                                                            src={inputs.beat_online_price === 'not_applicable' ? "../assets/images/radio-checked.webp" : "../assets/images/radio.webp"}
                                                                            className="img-fluid"
                                                                            alt="radio state"
                                                                        />*/}
                                                                        <Image
                                                                            src={
                                                                                inputs.beat_online_price === 'not_applicable'
                                                                                    ? process.env.REACT_APP_BASE_URL + 'assets/images/radio-checked.webp'
                                                                                    : process.env.REACT_APP_BASE_URL + 'assets/images/radio.webp'
                                                                            }
                                                                            className="img-fluid"
                                                                            alt="radio state"
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        {errors.beat_online_price && (<p className="text-danger">{errors.beat_online_price}</p>)}
                                                        <Col xs={12}>
                                                            <div className='and-note-text'>
                                                                <h6>lorem ipsum fsdsfsfdsfdsfsdf</h6>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {inputs.beat_online_price !== 'not_applicable' ? (
                                                        <>
                                                            <Row>
                                                                <Col sm={12} className="mb-3">
                                                                    <Form.Group >
                                                                        <Form.Label className=''>Online Price </Form.Label>
                                                                        <Form.Control type="text" placeholder="Enter Online price" name="online_price" onChange={handleInputChangeMRP} value={inputs.online_price} />
                                                                    </Form.Group>
                                                                    {errors.online_price && (<p className="text-danger">{errors.online_price}</p>)}
                                                                    <div className='and-note-text'>
                                                                        <h6>lorem ipsum fsdsfsfdsfdsfsdf</h6>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row className='mb-3'>
                                                                <Col xs={12}>
                                                                    <Form.Group>
                                                                        <Form.Label className=''>Online link </Form.Label>
                                                                        <Form.Control type="text" placeholder="Exa- www.amazon.com/iframe/mini" name="online_link" onChange={handleInputChange} value={inputs.online_link} />
                                                                    </Form.Group>
                                                                    {errors.online_link && (<p className="text-danger">{errors.online_link}</p>)}
                                                                    <div className='and-note-text'>
                                                                        <h6>lorem ipsum fsdsfsfdsfdsfsdf</h6>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    ) : null}
                                                    <Row className='mb-3'>
                                                        <Col xs={12} className=''>
                                                            <Form.Label className=''>Monthly Deal Limite <span className="text-danger">*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="monthly_deal_limite" onChange={handleInputChange} value={inputs.monthly_deal_limite}>
                                                                <option value="">Select monthly deal limite</option>
                                                                <option value="1">1</option>
                                                                <option value="2">2</option>
                                                                <option value="3">3</option>
                                                                <option value="4">4</option>
                                                                <option value="5">5</option>
                                                                <option value="6">6</option>
                                                                <option value="7">7</option>
                                                                <option value="8">8</option>
                                                                <option value="9">9</option>
                                                                <option value="10">10</option>
                                                                <option value="11">11</option>
                                                                <option value="12">12</option>
                                                                <option value="13">13</option>
                                                                <option value="14">14</option>
                                                                <option value="15">15</option>
                                                                <option value="16">16</option>
                                                                <option value="17">17</option>
                                                                <option value="18">18</option>
                                                                <option value="19">19</option>
                                                                <option value="20">20</option>
                                                                <option value="21">21</option>
                                                                <option value="22">22</option>
                                                                <option value="23">23</option>
                                                                <option value="24">24</option>
                                                                <option value="25">25</option>
                                                                <option value="26">26</option>
                                                                <option value="27">27</option>
                                                                <option value="28">28</option>
                                                                <option value="29">29</option>
                                                                <option value="30">30</option>
                                                                <option value="31">31</option>
                                                                <option value="32">32</option>
                                                                <option value="33">33</option>
                                                                <option value="34">34</option>
                                                                <option value="35">35</option>
                                                                <option value="36">36</option>
                                                                <option value="37">37</option>
                                                                <option value="38">38</option>
                                                                <option value="39">39</option>
                                                                <option value="40">40</option>
                                                                <option value="41">41</option>
                                                                <option value="42">42</option>
                                                                <option value="43">43</option>
                                                                <option value="44">44</option>
                                                                <option value="45">45</option>
                                                                <option value="46">46</option>
                                                                <option value="47">47</option>
                                                                <option value="48">48</option>
                                                                <option value="49">49</option>
                                                                <option value="50">50</option>
                                                                <option value="51">51</option>
                                                                <option value="52">52</option>
                                                                <option value="53">53</option>
                                                                <option value="54">54</option>
                                                                <option value="55">55</option>
                                                                <option value="56">56</option>
                                                                <option value="57">57</option>
                                                                <option value="58">58</option>
                                                                <option value="59">59</option>
                                                                <option value="60">60</option>
                                                                <option value="61">61</option>
                                                                <option value="62">62</option>
                                                                <option value="63">63</option>
                                                                <option value="64">64</option>
                                                                <option value="65">65</option>
                                                                <option value="66">66</option>
                                                                <option value="67">67</option>
                                                                <option value="68">68</option>
                                                                <option value="69">69</option>
                                                                <option value="70">70</option>
                                                                <option value="71">71</option>
                                                                <option value="72">72</option>
                                                                <option value="73">73</option>
                                                                <option value="74">74</option>
                                                                <option value="75">75</option>
                                                                <option value="76">76</option>
                                                                <option value="77">77</option>
                                                                <option value="78">78</option>
                                                                <option value="79">79</option>
                                                                <option value="80">80</option>
                                                                <option value="81">81</option>
                                                                <option value="82">82</option>
                                                                <option value="83">83</option>
                                                                <option value="84">84</option>
                                                                <option value="85">85</option>
                                                                <option value="86">86</option>
                                                                <option value="87">87</option>
                                                                <option value="88">88</option>
                                                                <option value="89">89</option>
                                                                <option value="90">90</option>
                                                                <option value="91">91</option>
                                                                <option value="92">92</option>
                                                                <option value="93">93</option>
                                                                <option value="94">94</option>
                                                                <option value="95">95</option>
                                                                <option value="96">96</option>
                                                                <option value="97">97</option>
                                                                <option value="98">98</option>
                                                                <option value="99">99</option>
                                                                <option value="100">100</option>
                                                            </Form.Select>
                                                            {errors.monthly_deal_limite && (<p className="text-danger">{errors.monthly_deal_limite}</p>)}
                                                        </Col>
                                                    </Row>
                                                    <Row className='mb-3'>
                                                        <Col xs={12} className=''>
                                                            <Form.Label className=''>Category <span className="text-danger">*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="category_id" onChange={handleInputChangeCat} value={inputs.category_id}>
                                                                <option value="">Category</option>
                                                                {category && category.map((val, index) => {
                                                                    return (
                                                                        <option value={val.id} data-cat-name={val.name}>{val.name}</option>
                                                                    )
                                                                })}
                                                            </Form.Select>
                                                            {errors.category_id && (<p className="text-danger">{errors.category_id}</p>)}
                                                        </Col>
                                                    </Row>
                                                    <Row className='mb-3'>
                                                        <Col xs={12} className=''>
                                                            <Form.Label className=''>Sub Category <span className="text-danger">*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="subcategory_id" onChange={handleInputChangeSubCat} value={inputs.subcategory_id}>
                                                                <option value="">Sub Category</option>
                                                                {subcategory && subcategory.map((val, index) => {
                                                                    return (
                                                                        <option value={val.id} data-subcat-name={val.name}>{val.name}</option>
                                                                    )
                                                                })}
                                                            </Form.Select>
                                                            {errors.subcategory_id && (<p className="text-danger">{errors.subcategory_id}</p>)}
                                                        </Col>
                                                    </Row>
                                                    <Row className='mb-3'>
                                                        <Col xs={12}>
                                                            <Form.Label className=''>Start Date <span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="date" placeholder="Start Date" name="deal_start_date" onChange={handleInputChange} value={inputs.deal_start_date} />
                                                            {errors.deal_start_date && (<p className="text-danger">{errors.deal_start_date}</p>)}
                                                            <div className='and-note-text'>
                                                                <h6>lorem ipsum fsdsfsfdsfdsfsdf</h6>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className='mb-3'>
                                                        <Col xs={12}>
                                                            <Form.Label className=''>End Date</Form.Label>
                                                            <Form.Control type="date" placeholder="End Date" name="deal_end_date" onChange={handleInputChange} value={inputs.deal_end_date} />
                                                            {errors.deal_end_date && (<p className="text-danger">{errors.deal_end_date}</p>)}
                                                            <div className='and-note-text'>
                                                                <h6>lorem ipsum fsdsfsfdsfdsfsdf</h6>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={12} className='setting-box'>
                                                            <div className='setting-single-box mb-0'>
                                                                <h6 className='fw-400'>Offering Home Delivery?</h6>
                                                                <Form.Check
                                                                    type="switch"
                                                                    id="notifications"
                                                                    checked={inputs.home_delivery === 1}
                                                                    onChange={handleChangeChk}
                                                                />
                                                            </div>

                                                        </Col>
                                                    </Row>
                                                    <div className='and-note d-none'>
                                                        <h6>Pick the months you want to offer a deal-it says valid all selected months unless manually disabled it.</h6>
                                                    </div>
                                                    <Button type="button" className='blue-icn-btn mt-4' onClick={handleShow}>
                                                        <h6>Next</h6>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/arrow-whi.webp'} className="img-fluid" alt="arrow-whi" />
                                                    </Button>
                                                </Form>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                <Modal
                                    size="lg"
                                    show={show}
                                    onHide={handleClose}
                                    backdrop="static"
                                    keyboard={false}
                                    className='deal-modal'
                                    centered
                                >
                                    <Modal.Header closeButton={isStep1 ? true : false}>

                                    </Modal.Header>
                                    <Modal.Body>


                                        {isStep1 &&
                                            <>

                                                <Row>
                                                    <Col xs={12} className="dd-tag">
                                                        <Link to="">{inputs.cat_name}</Link>
                                                        <p> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/right-arrow.webp'} className="img-fluid" alt="right-arrow" /> </p>
                                                        <Link to="">{inputs.sub_cat_name}</Link>
                                                    </Col>
                                                    <Col xs={12} className='d-none'>
                                                        <div className='dd-ld-box'>
                                                            <Dropdown>
                                                                <Dropdown.Toggle className='dd-like-box' variant="success" id="dropdown-like">
                                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" />
                                                                    <h6>12</h6>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className='dd-like-drop'>
                                                                    <Dropdown.Item href="#"><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" /> Great Price </div><span>1</span></Dropdown.Item>
                                                                    <Dropdown.Item href="#"><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" /> Good Quality Product </div><span>1</span></Dropdown.Item>
                                                                    <Dropdown.Item href="#"><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" /> Accurate Product Description </div><span></span></Dropdown.Item>
                                                                    <Dropdown.Item href="#"><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" /> Good Customer Service </div><span>3</span></Dropdown.Item>
                                                                    <Dropdown.Item href="#"><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" /> Other </div><span></span></Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                            <Dropdown>
                                                                <Dropdown.Toggle className='dd-dislike-box' variant="success" id="dropdown-dislike">
                                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" />
                                                                    <h6>5</h6>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className='dd-dislike-drop'>
                                                                    <Dropdown.Item href="$"><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" /> High Price </div><span>2</span></Dropdown.Item>
                                                                    <Dropdown.Item href="#"><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" /> Poor Quality Product/Service </div><span>3</span></Dropdown.Item>
                                                                    <Dropdown.Item href="#"><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" /> Incorrect Information </div><span>4</span></Dropdown.Item>
                                                                    <Dropdown.Item href="#"><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" /> Poor Customer Service </div><span>2</span></Dropdown.Item>
                                                                    <Dropdown.Item href="#"><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" /> Deal Was Denied by the Seller </div><span></span></Dropdown.Item>
                                                                    <Dropdown.Item href="#"><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" /> Spam </div><span></span></Dropdown.Item>
                                                                    <Dropdown.Item href="#"><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" /> Other </div><span>1</span></Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                            <div className='dd-hp-icn'>
                                                                <Link to="">
                                                                    <h6>17 Reviews</h6>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <div className='dd-img-box'>
                                                    <div className='dd-bop'>
                                                        {inputs.beat_online_price === 'yes' ? (
                                                            <h6>Beat Online Price</h6>
                                                        ) : null}
                                                    </div>
                                                    <Link to="/" className='blue-link dd-share d-none'><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/share-th.webp'} className="img-fluid" alt="share-th" /> </Link>
                                                    {/*<Image src={image.preview} className="img-fluid dd-banner banner-height" alt="dd-banner" />*/}

                                                    <Slider {...adsetting} className="slider-deal-add">
                                                        {images && images.length > 0 ? (

                                                            images.map((val1, index1) => {
                                                                return (
                                                                    <Image src={val1.url} className="img-fluid bd-banner" alt="ad-banner" />
                                                                );
                                                            })) : (
                                                            <Image
                                                                src={process.env.REACT_APP_BASE_URL + 'assets/images/default_deal.png'}
                                                                className="img-fluid bd-banner"
                                                                alt="default-banner"
                                                            />
                                                        )}
                                                    </Slider>

                                                </div>
                                                <Row>
                                                    <Col xs={12} sm className='dd-cont-left mt-2'>
                                                        <div>
                                                            {inputs.deal_type === "1" && (
                                                                <div className='d-flex align-center csb-title'>
                                                                    <div className='d-flex'>
                                                                        <strike className="me-2">
                                                                            <h5>Rs. {inputs.original_mrp}</h5>
                                                                        </strike>
                                                                        <h5>Rs. {inputs.sale_price}</h5>
                                                                    </div>
                                                                    <h6 className="peroff">{inputs.discount}% off</h6>
                                                                </div>
                                                            )}

                                                            {inputs.deal_type === "2" && (
                                                                <div className='d-flex align-center csb-title'>
                                                                    <div className='d-flex'>
                                                                        <h5>Buy {inputs.buy_qty} Get {inputs.get_qty}</h5>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        
                                                        <h3 className='my-2'>{inputs.listing_title}</h3>
                                                        {inputs.deal_end_date !== '' && (
                                                            <h6 className='dd-left-date'>Deal Expires : {moment(inputs.deal_end_date).format("D MMMM, YYYY")}</h6>
                                                        )}
                                                    </Col>
                                                </Row>
                                                <h5 className='fw-600 mt-3'>Details: </h5>
                                                <div>
                                                    <div className="">
                                                        <h6>
                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                    __html: inputs.description.replace(/\n/g, "<br/>")
                                                                }}
                                                            ></div>
                                                        </h6>
                                                    </div>


                                                </div>
                                                {inputs.home_delivery ? (
                                                    <>
                                                        <Row>
                                                            <Col md={12}>
                                                                <div className="dd-back-box">
                                                                    <h6>Delivery Options:</h6>
                                                                    <h6 className="fw-500">Home Delivery By Seller</h6>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                ) : null}
                                                <Row>
                                                    {inputs.online_link !== '' && inputs.online_price !== '' && (
                                                        <Col md={12}>
                                                            <div className='dd-back-box'>
                                                                <h6>Online competitor</h6>
                                                                <div className='dd-single-row'>
                                                                    <h6 className='fw-500'>{inputs.online_link ? inputs.online_link : ""}</h6>
                                                                    <h6 className='fw-500'>RS. {inputs.online_price ? inputs.online_price : ''}</h6>
                                                                </div>

                                                            </div>
                                                        </Col>
                                                    )}
                                                </Row>

                                                <Row>
                                                    <Col md={12}>
                                                        <h5 className='fw-600 mt-3'>Business Details: </h5>
                                                    </Col>
                                                    <Col md={12}>
                                                        <div className='dd-mobile-box'>
                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/business.webp'} className="img-fluid" alt="business" />
                                                            <h6 className='mb-0'>{inputsb.business_name}</h6>
                                                        </div>
                                                    </Col>
                                                    <Col md={12}>
                                                        <div className='dd-mobile-box'>
                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/map-dd.webp'} className="img-fluid" alt="map-dd" />
                                                            <h6 className='mb-0'>{inputsb.address}</h6>
                                                        </div>
                                                    </Col>
                                                    <Col md={12}>
                                                        <Row>
                                                            <Col md={12} className='dd-cpy-icn'>
                                                                <Row>
                                                                    <Col xs="auto" className='dd-mobile-box'>
                                                                        <h6><span className='fw-500'>Contact :</span> {inputsb.business_contact_number}</h6>
                                                                    </Col>
                                                                    <Col xs="auto">
                                                                        <Link to="/">
                                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/copy.webp'} className="img-fluid" alt="copy" />
                                                                            <h6>Copy</h6>
                                                                        </Link>
                                                                    </Col>
                                                                    <Col xs="auto">
                                                                        <Link to="/">
                                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/call.webp'} className="img-fluid" alt="call" />
                                                                            <h6>Call</h6>
                                                                        </Link>
                                                                    </Col>
                                                                    <Col xs="auto">
                                                                        <Link to="/">
                                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/whatsapp-round.webp'} className="img-fluid" alt="whatsapp-round" />
                                                                            <h6>WhatsApp</h6>
                                                                        </Link>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Col>

                                                </Row>
                                                <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
                                              <GoogleMap
                                                mapContainerStyle={containerStyle}
                                                center={center}
                                                zoom={15}
                                              >
                                                <Marker position={center} />
                                              </GoogleMap>
                                            </LoadScript>
                                                {/*<Image src={process.env.REACT_APP_BASE_URL + 'assets/images/map.webp'} className="img-fluid dd-map" alt="map" />*/}
                                                <Row>
                                                    <Col xs={12}>
                                                        <Link to="" className='blue-link' onClick={wantHandlePublish}>Want to publish</Link>
                                                    </Col>
                                                </Row>
                                            </>
                                        }

                                        <Row>
                                            {isStep2 &&
                                                <><Col xs={6}>
                                                    <div className='blue-link' onClick={handleClose}>Close</div>
                                                </Col><Col xs={6}>
                                                        <Link to="" className='blue-link' onClick={handlePublish}>Publish</Link>
                                                    </Col></>
                                            }
                                            {isVisibleMsg &&
                                                <>
                                                    <Col xs={12} className='mt-3'>
                                                        <h5>Your deal has been submitted and is now under review. It will go live within 3 business days.</h5>
                                                    </Col>
                                                    <Col xs={12} className='mt-3'>
                                                        <div className='blue-link' onClick={handleView}>View All Deal</div>
                                                    </Col>
                                                </>
                                            }
                                        </Row>

                                    </Modal.Body>
                                </Modal>
                                <div className='footer-org footer'>
                                    <Footer />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {loading && (
                <div className="loadingClass">
                    <img src={loader} alt="loader" />
                </div>
            )}
        </>
    )
}

export default ProductSale;


